// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBIgmuB1ZX6I2KXvV1FhXnbTigCJWax16Y",
  authDomain: "producer-feedback.firebaseapp.com",
  projectId: "producer-feedback",
  storageBucket: "producer-feedback.firebasestorage.app",
  messagingSenderId: "396360774469",
  appId: "1:396360774469:web:280c60679c3a646298842c",
  measurementId: "G-892VBZJQK3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Firebase Auth persistence set to local.");
  })
  .catch((error) => {
    console.error("Error setting Firebase Auth persistence:", error);
  });